/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { CA_STORAGE_KEY, MI_STORAGE_KEY } from '../components';
import { BaseLevelSnippetResp, SnippetsTableModes } from '../types';

const getBaseLevelSnippetIds = (baseLevelSnippetData: BaseLevelSnippetResp[]) =>
  baseLevelSnippetData.map((s) => s.id.toString());

/**
 * This hook is used to determine whether we should display the Collapse All button
 * by returning whether any top-level snippets are expanded.
 */
export const useGetIsExpanded = (
  baseLevelSnippetData: BaseLevelSnippetResp[],
  mode: SnippetsTableModes = SnippetsTableModes.CampaignAnalytics,
) => {
  const [storageValue, setStorageValue] = useState({} as { [path: string]: boolean });
  const [reset, setReset] = useState(false);
  const updateIsExpanded = () => setReset(!reset);

  const storageKey =
    mode === SnippetsTableModes.CampaignAnalytics ? CA_STORAGE_KEY : MI_STORAGE_KEY;

  // Utilize updated local storage values
  useEffect(() => {
    const val = localStorage.getItem(`json-collapse-${storageKey}`);
    const jsonVal = val ? JSON.parse(val) : {};
    setStorageValue(jsonVal);
  }, [reset]);

  const baseLevelSnippetIds = getBaseLevelSnippetIds(baseLevelSnippetData);

  const expandedBaseLevelSnippets = Object.entries(storageValue || {})
    .filter(([id, isCollapsed]) => baseLevelSnippetIds.includes(id) && !isCollapsed)
    .map(([id, _]) => parseInt(id, 10));

  const isExpanded = expandedBaseLevelSnippets.length > 0;

  return { isExpanded, expandedBaseLevelSnippets, updateIsExpanded };
};
